import { some } from '@utils/some';
import Cookie from 'js-cookie';
import { parseTablesDetailsForBasket } from './parseTablesDetailsForBasket';
import { parseSpaExperiencesForBasket } from './parseSpaExperiencesForBasket';
import { addToBasket, AddToBasketProps } from './addToBasket';
import { mergeGuestData } from './mergeGuestData';

export const appendSpaAndTableToRoomsItemInBasket = (props: AddToBasketProps) => {
  const {
    updateBasket,
    createBasket,
    bookingDetails,
    fromDate,
    toDate,
    property,
    language,
    basketDetails,
    showConfirmation,
    spaPackageId,
    spaOpenTime,
    spaCloseTime,
    maxGuestsPerExperience,
    loggedInUserGuestData,
    isPackageRepeating,
    experienceGuestStartIndex = 0,
    roomNumber = 0,
    existingBasketId = undefined,
    existingBasketItems = [],
    packageParentId,
  } = props;

  const basketId = existingBasketId || Cookie.get('basketId');
  const tablesDetails = bookingDetails?.tables;
  const spaDetails = bookingDetails?.experiences || [];
  const spaExtras = bookingDetails.spaExtras;
  const basketItems = some(existingBasketItems) ? existingBasketItems : basketDetails?.items || [];
  const tablesDetailsForBasket = tablesDetails
    ? parseTablesDetailsForBasket({ tablesDetails, parentBasketId: packageParentId })
    : [];
  const existingGuests = (basketItems || []).flatMap((item) => item.guestDetails);
  const roomGuests = some(spaDetails.guestDetails)
    ? spaDetails.guestDetails.filter((guest) => guest.roomNumber === roomNumber)
    : [];
  const roomGuestOptions = some(spaDetails.guestOptions)
    ? spaDetails.guestOptions.slice(
        experienceGuestStartIndex,
        experienceGuestStartIndex + roomGuests.length
      )
    : [];

  const mergedGuests = mergeGuestData(existingGuests, roomGuests);
  const spaDetailsForBasket =
    spaDetails && some(spaDetails.guestOptions)
      ? parseSpaExperiencesForBasket(
          { ...spaDetails, guestDetails: mergedGuests, guestOptions: roomGuestOptions },
          spaExtras,
          spaPackageId,
          fromDate,
          toDate,
          spaOpenTime,
          spaCloseTime,
          maxGuestsPerExperience,
          loggedInUserGuestData ?? null,
          isPackageRepeating,
          packageParentId
        )
      : [];

  const items = [...(roomNumber === 0 ? tablesDetailsForBasket : []), ...spaDetailsForBasket];

  if (basketId) {
    return updateBasket(
      property.id,
      basketId,
      language,
      {
        items: [...basketItems, ...items].filter((item) => !!item),
      },
      property.slug,
      property.timezone,
      true
    ).then((response) => {
      if (roomNumber === bookingDetails.guests.rooms.length - 1) {
        showConfirmation();
      } else {
        addToBasket({
          ...props,
          experienceGuestStartIndex: experienceGuestStartIndex + roomGuests.length,
          roomNumber: roomNumber + 1,
          existingBasketId: response.payload.id,
          existingBasketItems: response.payload.items,
        });
      }
    });
  } else {
    return createBasket(
      property.id,
      language,
      { items: items.filter((item) => !!item) },
      property.slug,
      property.timezone,
      true
    ).then((response) => {
      if (roomNumber === bookingDetails.guests.rooms.length - 1) {
        showConfirmation();
      } else {
        addToBasket({
          ...props,
          experienceGuestStartIndex: experienceGuestStartIndex + roomGuests.length,
          roomNumber: roomNumber + 1,
          existingBasketId: response.payload.id,
          existingBasketItems: response.payload.items,
        });
      }
    });
  }
};
